var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTiles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3V4H3V3H4ZM10 4L11 4.00001V9.99947L10 10L9.99999 11H4.00099L4 10L3 9.99999V4H4V3H9.99901L10 4ZM4 10L3 9.99999V11H4.00099L4 10ZM5 9H9V5H5V9ZM10 10L9.99999 11H11V9.99947L10 10ZM11 4.00001L10 4L9.99901 3H11V4.00001Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3V4H13V3H14ZM20 4L21 4.00001V9.99947L20 10L20 11H14.001L14 10L13 9.99999V4H14V3H19.999L20 4ZM14 10L13 9.99999V11H14.001L14 10ZM15 9H19V5H15V9ZM20 10L20 11H21V9.99947L20 10ZM21 4.00001L20 4L19.999 3H21V4.00001Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 13V14H13V13H14ZM20 14L21 14V19.9995L20 20L20 21H14.001L14 20L13 20V14H14V13H19.999L20 14ZM14 20L13 20V21H14.001L14 20ZM15 19H19V15H15V19ZM20 20L20 21H21V19.9995L20 20ZM21 14L20 14L19.999 13H21V14Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 13V14H3V13H4ZM10 14L11 14V19.9995L10 20L9.99999 21H4.00099L4 20L3 20V14H4V13H9.99901L10 14ZM4 20L3 20V21H4.00099L4 20ZM5 19H9V15H5V19ZM10 20L9.99999 21H11V19.9995L10 20ZM11 14L10 14L9.99901 13H11V14Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiles);
export default __webpack_public_path__ + "static/media/tiles.d723cda42c0305cb87baf71b06075b38.svg";
export { ForwardRef as ReactComponent };